import { Link } from "react-router-dom";

interface DailyCardProps {
  rank: number;
  title: string;
  desc: string;
  hot: string;
  imageUrl: string;
  categorySlug: string;
}

export default function DailyCard({ rank, title, desc, hot, imageUrl, categorySlug }: DailyCardProps) {
  return (
    <Link
      to="/"
      className="flex-shrink-0 w-[280px] md:w-[320px] group cursor-pointer"
    >
      <div className="rounded-lg overflow-hidden bg-background-50">
        <div className="relative aspect-[3/2] overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            title={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute top-2 left-2 w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-full bg-background-900/80 text-white text-sm font-bold">
            {rank}
          </div>
        </div>
        <div className="p-3 md:p-4">
          <p className="text-xs text-secondary-600 mb-1">每日大赛</p>
          <h4 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-1 mb-1">
            {title}
          </h4>
          <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
            {desc}
          </p>
          <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-fire-line text-xs"></i>
            </div>
            {hot}热度
          </span>
        </div>
      </div>
    </Link>
  );
}